import presetPack from '@yandex-int/csp-presets-pack'

import {hostByBrandByEnv} from '../../../../../hosts'
import {CSP, METRICA_DOMAINS} from '../../../../constants'
import type {Preset} from '../../../../types'

const metrikaPreset = presetPack.metrika(['ru', 'com']) as Preset
const S3_DOMAIN = hostByBrandByEnv.yango.production.s3.default

export const METRICA = {
  [CSP.SCRIPT]: [
    ...(metrikaPreset[CSP.SCRIPT]?.filter(item => item.includes('yastatic.net')) || []),
    S3_DOMAIN,
    'mc.yango.com',
  ],
  [CSP.IMG]: [
    ...(metrikaPreset[CSP.IMG]?.filter(item => item.includes('yastatic.net')) || []),
    S3_DOMAIN,
    'mc.yandex.ru',
    'mc.yango.com',
  ],
  [CSP.CONNECT]: [...(metrikaPreset[CSP.CONNECT] || []), 'mc.yango.com', 'mc.yandex.md', 'wss://mc.yandex.ru'],
  [CSP.CHILD]: [...(metrikaPreset[CSP.CHILD] || []), 'mc.yandex.com', 'mc.yango.com'],
  [CSP.FRAME]: [...(metrikaPreset[CSP.FRAME] || []), 'mc.yango.com', 'mc.yandex.com'],
  [CSP.FRAME_ANCESTORS]: [...(metrikaPreset[CSP.FRAME_ANCESTORS] || []), ...METRICA_DOMAINS],
} as const satisfies Preset
